export default __webpack_public_path__ + "static/media/world-card.d018c5b5.webp";